export default __webpack_public_path__ + "static/media/waterfall.3c64777c.mp3";